// DS: C59
/** Main part of the popup and modal with links to share a deviation on social media */
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import copy from 'copy-to-clipboard';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import InputSuccessMessage from '@wix/da-ds/pkg/formControls/lego/InputSuccessMessage';
import SocialShareButtons from '../../../SocialShareButtons';
import s from './DesktopShareContent.scss';
var DesktopShareContent = function (_a) {
    var url = _a.url, title = _a.title, embedCode = _a.embedCode, media = _a.media, biData = _a.biData;
    var t = useTranslation().t;
    var inputRef = useRef(null);
    var _b = useState('none'), copied = _b[0], setCopied = _b[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(SocialShareButtons, { url: url, title: title || url, media: media, buttons: ['facebook', 'twitter', 'tumblr', 'pinterest'], iconSize: 42, iconBgColor: "#0e0d20" // L8
            , logoFillColor: "#00e59b" // G3
            , biData: biData }),
        React.createElement("div", { className: s['first-copy-input'] },
            React.createElement(TextInput, { id: "deviation-url-to-copy", value: url, label: t('share.linkUrl'), details: copied === 'url' ? (React.createElement(InputSuccessMessage, null, t('share.copied'))) : undefined, ref: inputRef, onClick: function () {
                    var _a;
                    copy(url);
                    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.select();
                    setCopied('url');
                } })),
        embedCode && (React.createElement("div", null,
            React.createElement(TextInput, { id: "deviation-url-to-copy", value: embedCode, label: t('share.embed'), details: copied === 'embed' ? (React.createElement(InputSuccessMessage, null, t('share.copied'))) : undefined, ref: inputRef, onClick: function () {
                    var _a;
                    copy(embedCode);
                    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.select();
                    setCopied('embed');
                } })))));
};
DesktopShareContent.displayName = 'DesktopShareContent';
export default DesktopShareContent;
//# sourceMappingURL=DesktopShareContent.js.map